<template>
  <div id="collections">
    <div class="d-flex justify-content-start align-items-start mb-4 w-100" :class="isPhone ? 'mt-5' : ''">
      <div class="back-button d-flex align-items-center justify-content-center" :class="isPhone ? 'ml-3' : 'ml-5'" @click="close()">
        <img src="../../images/arrow-left-small.svg" alt="Back" style="width: 15px; height: 17.5px;" />
      </div>
    </div>
    <div class="top-banner w-100">
      <div class="image-gradient-bottom"></div>
      <div class="top-banner-content">
        <p :class="isPhone ? 'merriweather-reg-32' : 'merriweather-reg-40'">Nos collections</p>
        <p :class="isPhone ? 'merriweather-light-reg-18' : 'merriweather-light-reg-26'">Des séjours pensés pour chaque envie.</p>
      </div> 
    </div>
    <div class="collections-layout w-100" :class="isPhone ? 'pt-3' : 'pt-5'">
      <div class="collections-sidebar" :class="isPhone ? 'px-3 pt-3' : ''">
        <div
          v-for="(section, idx) in sectionNames"
          :key="section"
          :class="['sidebar-section', 'raleway-bold-p15', { active: idx === activeSectionIndex }]"
          :style="`${section == 'NOS AUTRES COLLECTIONS D’EXCEPTION' ? 'min-width: 230px;' : ''}`"
          @click="activeSectionIndex = idx"
        >
          {{ section }}
        </div>
      </div>
      <div class="collections-content pt-5">
        <div class="w-100">
          <div
            v-for="(section, idx) in sectionNames"
            :key="section"
            v-show="idx === activeSectionIndex"
          >
            <SectionBlock
              :title="sectionTitles[idx]"
              :subtitle="sectionSubtitles[idx]"
              :description="sectionDescriptions[idx]"
              :collections="selectedCollections"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 pb-5">
      <AccommodationCard 
        v-if="!isPhone"
        :user="this.user"
        :lodgings="accommodations"
        :buttonText="'Découvrir toutes les nouveautés'"
        @collectionSelected="selectedCollection = $event"
      />
      <AccommodationPhoneCard v-else :user='user' :lodgings="accommodations" :buttonText="'Découvrir toutes les nouveautés'" @collectionSelected="selectedCollection = $event"></AccommodationPhoneCard>
    </div>
  </div>
</template>

<script>
import AOS from "aos";
import CardColl from "pages/collections/CardColl.vue";
import fetcher from "packs/shared/api.js";
import Searchbtn from "components/btns/Searchbtn.vue";
import Searchbanner from "components/btns/Searchbanner.vue";
import SectionBlock from "./SectionBlock.vue";
import AccommodationCard from "components/cards/AccommodationCard.vue";
import AccommodationPhoneCard from "components/cards/AccommodationPhoneCard.vue";

export default {
  name: "collections",
  props: ["collections", "user"],
  components: { CardColl, Searchbtn, Searchbanner, SectionBlock, AccommodationCard, AccommodationPhoneCard },
  data() {
    return {
      showBanner: false,
      collectionsMounted: [],
      activeSectionIndex: 0,
      sectionNames: [
        "ÉVASIONS DE SAISON",
        "L'APPEL DES GRANDS HORIZONS",
        "ESCAPADE À DEUX",
        "SOUS LE SIGNE DU SOLEIL",
        "VOYAGE DES SENS",
        "VIVRE ENSEMBLE",
        "ESCAPADES URBAINES",
        "NOS AUTRES COLLECTIONS D’EXCEPTION",
      ],
      sectionTitles: [
        "Évasions",
        "L'appel",
        "Escapade",
        "Sous le signe",
        "Voyage",
        "Vivre",
        "Escapades",
        "Nos autres collections",
      ],
      sectionSubtitles: [
        "de saison",
        "des grands horizons",
        "à deux",
        "du soleil",
        "des sens",
        "ensemble",
        "urbaines",
        "d’exception",
      ],
      groupedCollections: [
        ["vacances-ete", "vacances-printemps", "vacances-noel", "vacances-hiver", "vacances-toussaint"],
        ["sejour-nature", "sejour-montagne", "sejour-au-bord-de-eau", "sejour-campagne"],
        ["sejour-amoureux", "sejour-romantique", "voyage-de-noces"],
        ["sejour-soleil", "sejour-mer", "sejour-piscine"],
        ["sejour-oenologique", "sejour-gastronomique"],
        ["sejour-en-famille", "location-maison-de-charme"],
        ["city-break", "voyage-affaires"],
        ["chambre-hotes", "sejour-insolite", "sejour-chateau", "evenement-eco-responsable"],
      ],
      selectedCollections: [] ,
      accommodations: [],  
      selectedCollection: null
    };
  },
  methods: {
    close() {
      window.history.back();
    },
    redirectToTop() {
      window.scrollTo(0, "#navbar");
    },
    async fetchAllCollections() {
      try {
        const response = await fetcher.get("/collections.json");
        this.collectionsMounted = response.data;
        this.groupCollectionsBySection();
      } catch (e) {
        console.error(e);
      }
    },
    groupCollectionsBySection() {
      const vacationCollections = {
        "vacances-ete": {
          name: "Vacances d'été",
          title: "Sous le soleil",
          image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-ete.webp",
          slug: "vacances-ete"
        },
        "vacances-printemps": {
          name: "Vacances de printemps",
          title: "Réveil de la Nature",
          image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-printemps.webp",
          slug: "vacances-printemps"
        },
        "vacances-noel": {
          name: "Vacances de Noël",
          title: "Au coeur des fêtes",
          image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-noel.webp",
          slug: "vacances-noel"
        },
        "vacances-hiver": {
          name: "Vacances d'hiver",
          title: "Charme hivernal",
          image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-hiver.webp",
          slug: "vacances-hiver"
        },
        "vacances-toussaint": {
          name: "Vacances de la Toussaint",
          title: "Couleurs d'automne",
          image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-toussaint.webp",
          slug: "vacances-toussaint"
        }
      };

      const currentGroupSlugs = this.groupedCollections[this.activeSectionIndex] || [];
      
      // Check if we're in the "Évasions de Saison" section (index 0)
      if (this.activeSectionIndex === 0) {
        // For vacation collections, create explicit entries
        this.selectedCollections = currentGroupSlugs.map(slug => {
          if (vacationCollections[slug]) {
            return vacationCollections[slug];
          }
          // Fallback to mounted collections if available
          return this.collectionsMounted.find(coll => coll.slug === slug);
        }).filter(Boolean);
      } else {
        // For other sections, use the mounted collections
        this.selectedCollections = this.collectionsMounted.filter(coll =>
          currentGroupSlugs.includes(coll.slug)
        );
      }
    },
    async fetchHomeLoadings() {
      const responseAccommodation = await fetcher.get(
          "/home_lodgings", {
            params: { collection: this.selectedCollection }
          }
        );
      this.accommodations = responseAccommodation.data;
    },
  },
  computed: {
    isPhone() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    sectionDescriptions() {
        return [
          `Pendant vos vacances, profitez de <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span> qui rendent chaque escapade encore plus spéciale`,
          `L’évasion grandiose, avec des <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span> rien que pour vous`,
          `Moments d’exception à deux, avec <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span> uniques`,
          `Le soleil, la mer, la piscine et des <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges uniques</span>`,
          `Bien-être et relaxation, avec des <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span> à découvrir`,
          `Dégustation et découvertes, des <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span> pour vos papilles`,
          `Moments à partager, avec des <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span> pour tous`,
          `Évasion citadine, avec des <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges uniques</span> pour chaque séjour`,
          `Nos collections exclusives, avec des <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges</span> réservés à nos membre`
      ]
    }
  },
  watch: {
    activeSectionIndex() {
      this.groupCollectionsBySection();
    },
    selectedCollection() {
      this.fetchHomeLoadings();
    }
  },
  mounted() {
    AOS.init({
      duration: 1200,
      once: true,
    });
    this.lodgings = [];
    this.fetchHomeLoadings()
    this.fetchAllCollections();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_item_list",
      item_list_name: "collection_lodgings_list",
      item_list_id: "collection_lodgings",
    });
  },
};
</script>

<style lang="scss" scoped>
#collections {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .top-banner {
    height: 420px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/collection-hortense.webp');
    background-size: cover;

    .top-banner-content {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #F7F7F7;
    }

    .image-gradient-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 115%;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
      pointer-events: none;
    }
  }
}
.collections-layout {
  display: flex;
  min-height: 100vh;
}
.collections-sidebar {
  width: 350px;
  background: #fff;
  border-right: 1px solid #BFBFBF;
  padding: 88px 93px 88px 64px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  gap: 56px;
}
.sidebar-section {
  cursor: pointer;
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #000000B2;

  &:hover {
    color: black;
  }
}
.sidebar-section.active {
  color: black;
  border-bottom: 1.5px solid #3B6152;
  padding-bottom: 2px;
}
.collections-content {
  flex: 1;
  padding: 0 0 0 0;
}
.section-block {
  margin-bottom: 60px;
}

.back-button {
  width: 33px;
  height: 33px;
  background: #BFBFBF;
  border-radius: 8.25px;
  z-index: 1;
  top: 0;
  position: relative;
}

@media (max-width: 768px) {
  .collections-layout {
    flex-direction: column;
  }
  .collections-sidebar {
    width: 100%;
    flex-direction: row;
    border-right: none;
    padding: 0 0 0 0;
    min-height: unset;
    justify-content: flex-start;
    gap: 15px;
    overflow-x: auto;
  }
  .sidebar-section {
    min-width: 150px;
    text-align: center;
    min-height: 50px;
  }
  .sidebar-section.active {
    border-bottom: 1.5px solid #3b6152;
    border-left: none;
    padding-bottom: 2px;
  }
  .collections-content {
    padding: 0;
  }
  #accommodations-phone {
    padding-top: 0 !important;
  }

  .top-banner {
    height: 368px;
    background-position: center;

    .top-banner-content {
      padding: 40px;
    }
  }

  .back-button {
    margin-top: 85px;
  }
}

</style>
